/**
 * Formats an XP number using dots as thousand separators (e.g. 1.250, 10.000).
 * Uses 'de-DE' locale which uses dots, regardless of the UI language.
 */
export function formatXP(value: number): string {
  return value.toLocaleString('de-DE');
}
